<template>
  <div>
    <nn-notification v-if="status === 'error'" type="error">
      {{ errorMessage }}
      <div>(code: {{ this.errorCode }})</div>
      <nn-button @click="redirectToLogin" class="c-button c-button--secondary">
        terug naar inloggen
      </nn-button>
    </nn-notification>

    <div
      v-if="status === 'showLogin'"
      data-test="coupleLoginScreen"
      class="o-layout__row justify-content-center"
    >
      <div class="o-layout__col-xl-8 u-margin-bottom--20">
        <couple-eherkenning
          :config="config"
          @onHandleForgeRockError="handleForgeRockError($event)"
          @firstTimeCoupled="status = 'firstTimeCoupled'"
        ></couple-eherkenning>
      </div>
    </div>

    <nn-notification v-if="status === 'firstTimeCoupled'" type="success">
      <h2 class="notification-margin">
        Gelukt! Vanaf nu logt u in met eHerkenning
      </h2>
      <p>
        We hebben je account successful gekoppeld aan eHerkenning. Dat betekend
        dat je voortaan inlogt met eHerkenning bij adviseur.nn.nl
      </p>
      <nn-button @click="redirectToHome" class="c-button c-button--secondary">
        naar de homepage
      </nn-button>
    </nn-notification>

    <nn-notification v-if="status === 'timeout'" type="warning">
      <h2 class="notification-margin">Uw sessie is verlopen</h2>
      <p>
        De sessie verloopt na 15 minuten. Ga terug naar het inlog scherm en
        begin opnieuw
      </p>
      <nn-button @click="redirectToLogin" class="c-button c-button--secondary">
        terug naar inloggen
      </nn-button>
    </nn-notification>

    <already-coupled v-if="status === 'alreadyCoupled'" />

    <not-found
      v-if="status === 'notFound'"
      :contactNum="config.contactNum"
      :contactForm="config.contactForm"
    />
  </div>
</template>

<script>
import AlreadyCoupled from "../components/AlreadyCoupled";
import NotFound from "../components/NotFound";
import CoupleEherkenning from "../components/CoupleEherkenning";
import { forgeRockCodes, errorMessages } from "../amResponseCodes";
import { redirect } from "@nn/psdl-utility/src/redirect";
import { clearSessionStorage } from '../utils/helpers';

export default {
  name: "Home",
  components: { AlreadyCoupled, NotFound, CoupleEherkenning },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      errorCode: "",
      status: "showLogin"
    };
  },
  computed: {
    errorMessage() {
      return errorMessages[this.errorCode] || errorMessages.DEFAULT_ERROR_MESSAGE;
    }
  },
  methods: {
    handleForgeRockError(e) {
      this.status = "showLogin";
      this.errorCode = "";

      if (e.message === forgeRockCodes.TIMEOUT) {
        this.status = "timeout";
      } else if (e.message === forgeRockCodes.ALREADY_COUPLED) {
        this.status = "alreadyCoupled";
      } else if (e.message === forgeRockCodes.NOT_FOUND) {
        this.status = "notFound";
      } else {
        this.status = 'error';
        this.errorCode = e.message;
      }
    },
    redirectToHome() {
      clearSessionStorage();
      redirect(this.config.productPage);
    },
    redirectToLogin() {
      clearSessionStorage();
      redirect(this.config.eHerkenningCancelPage);
    }
  }
};
</script>

<style lang="scss" scoped>
.notification-margin {
  margin-bottom: 0.75rem;
}
</style>
